import Axios from 'axios';
import moment from 'moment';
import { fetchCardInfo } from '@/api/card';
import { formatDate, singleton } from '@/utils';
import { LockVendor, LockVendorMap } from '../config';

/**
 * 单例连接开始
 */
type ObjectValues<T> = T extends object ? T[keyof T] : never;
type LockType = { lockType: ObjectValues<typeof LockVendorMap> };

export class MyDoorLockCardClass {
  baseUrl: string;

  constructor() {
    this.baseUrl = 'http://127.0.0.1:39090';
  }

  readCard(params: LockType) {
    const url = `${this.baseUrl}/lock/be/check`;
    return Axios.post(url, params).then((res) => res.data);
  }

  createCard(params: { roomNo: number; beginTime: string; endTime: string } & LockType) {
    const url = `${this.baseUrl}/lock/be/issue`;
    return Axios.post(url, params).then((res) => res.data);
  }

  updateCard(params: { roomNo: number; beginTime: string; endTime: string } & LockType) {
    const url = `${this.baseUrl}/lock/be/update`;
    return Axios.post(url, params).then((res) => res.data);
  }

  deleteCard(params: LockType) {
    const url = `${this.baseUrl}/lock/be/disable`;
    return Axios.post(url, params).then((res) => res.data);
  }

  // 启用、停用
  setOpen(params?: { commonCode: string } & LockType) {
    const url = `${this.baseUrl}/lock/be/setOpen`;
    return Axios.post(url, params).then((res) => res.data);
  }

  setClose(params?: { commonCode: string } & LockType) {
    const url = `${this.baseUrl}/lock/be/setClose`;
    return Axios.post(url, params).then((res) => res.data);
  }
}

export const SingleCardProxyClass = singleton(MyDoorLockCardClass);
/**
 * 单例连接结束
 */

// 卡操作维度
export enum CardOperateType {
  Create = 'create',
  Update = 'update',
  Read = 'read',
  Delete = 'delete',
}

// 卡状态
export enum CardStatus {
  Empty = 'empty',
  Exception = 'exception',
  Info = 'Info',
}

// 卡操作流程
export enum CardOperateProcessingStatus {
  Init = 'Init',
  Loading = 'Loading',
  RequestError = 'RequestError',
  RequestSuccess = 'RequestSuccess',
}

type TRequestCardInfo = {
  hotelId: string;
  resvNo: string;
  recNo: string;
  cardNo: string;
  roomNo: string;
  roomId: number;
  lockNo: string;
  validityStartTime: string;
  validityEndTime: string;
};

/* eslint-disable camelcase */
export interface ICardInfo {
  card_id: string;
  begin_time: string;
  end_time: string;
  card_no: number; // 会自增
  card_type: string;
  door_id: string;
  issue_type: string;
  room_no: string;

  cardStatus: CardStatus;
  requestCardInfo: TRequestCardInfo;
}

export const isDataNormalUpdateCard = async (cardInfo: ICardInfo, roomId) => {
  if (!cardInfo?.card_id) {
    return false;
  }

  try {
    const { data, status } = await fetchCardInfo({
      cardNo: cardInfo.card_id,
    });
    if (!status || !data) {
      return false;
    }

    if (
      data.roomId === roomId &&
      // PMS上次记录的预离时间和当前卡信息预离时间
      formatDate(data.validityEndTime, 'YYMMDDHHmm') ===
        moment(cardInfo.end_time).format('YYMMDDHHmm')
    ) {
      return true;
    }
  } catch (error) {
    //
  }
  return false;
};

type TemptyAndDataAccuracyStrategyMap = Record<
  LockVendor.BE_LINE,
  {
    successFulCodeList: Array<number>;
    isEmptyCard: (vals: { code: number; data: ICardInfo }) => boolean;
    updateCardStatus: (vals: { code: number; data: ICardInfo }) => ICardInfo;
  }
>;
// 空白卡、数据是否符合判断（卡类型维度）
export const emptyAndDataAccuracyStrategyMap: TemptyAndDataAccuracyStrategyMap = {
  [LockVendor.BE_LINE]: {
    successFulCodeList: [0, 10014],
    // 空白卡判断
    isEmptyCard: (res) => res?.code === 10014,
    updateCardStatus: (res) => {
      if (res.code === 10014) {
        return { ...res.data, cardStatus: CardStatus.Empty };
      }
      return res.data;
    },
  },
};
